import React, { Component } from 'react';
import ReactTable from 'react-table';
import i18n from '../../i18n';
import SalesBasketManager from '../util/SalesBasketManager';
import SessionManager from '../util/SessionManager';
import Grid from '../components/Grid';
import Dialog from './Dialog';
import { formatCurrency, formatUnitPrice } from '../util/HelpfulFunctions';

//props input : onBasketModified, detailsList

const currencyFormatter = Intl.NumberFormat(SessionManager.language, { style: "currency", currency: SessionManager.currency, minimumFractionDigits: 2 });
const unitPriceFormatter = Intl.NumberFormat(SessionManager.language, { style: "currency", currency: SessionManager.currency, minimumFractionDigits: 5 });
class SalesBasketList extends Component {

    constructor(props) {
        super(props);

        this.state = {
            items: this.InitializeData()
        };

        this.renderStdCell = this.renderStdCell.bind(this);
        this.renderButtonCell = this.renderButtonCell.bind(this);
        this.renderQtyCell = this.renderQtyCell.bind(this);
        this.renderMessage = this.renderMessage.bind(this);
        this.renderMobileCell = this.renderMobileCell.bind(this);

        window.onresize = (event) => {
            console.log(event);
        };
    }

    InitializeData() {
        if (this.props.detailsList) {
            return this.getDetailsData(this.props.detailsList);
        }
        else {
            return SalesBasketManager.basketItems;
        }
    }

    render() {
        if (this.state.items.length === 0)
            return (<div/>);

        return (
            <div>
                {this.renderList()}
                {this.renderMessage()}
            </div>
        );
    }

    renderList() {

        const columns = [
            {
                accessor: "ItemCode",
                maxWidth: 150,
                Header: i18n.t("Κωδικός"),
                headerClassName: "text-center desktop",
                className: "text-center m-auto desktop",
                Cell: this.renderStdCell
            },
            {
                accessor: "Description",
                minWidth: 180,
                Header: i18n.t("Περιγραφή"),
                headerClassName: "desktop text-center",
                className: "desktop text-center text-wrap m-auto",
                Cell: this.renderStdCell
            },
            {
                accessor: "Quantity",
                Header: i18n.t("Ποσότητα"),
                maxWidth: 320,
                headerClassName: "desktop text-center",
                className: "desktop text-center m-auto",
                Cell: this.renderQtyCell
            }
        ];

        if (this.props.displayAmounts) {
            columns.push({
                accessor: "UnitPrice",
                Header: i18n.t("Τιμή"),
                headerClassName: "desktop text-center",
                className: "desktop text-center m-auto",
                formatter: unitPriceFormatter,
                Cell: this.renderStdCell
            });

            columns.push({
                accessor: "GrossValue",
                Header: i18n.t("Αξία"),
                headerClassName: "desktop text-center",
                formatter: currencyFormatter,
                className: "desktop text-center m-auto",
                Cell: this.renderStdCell
            });
        }

        if (!this.props.detailsList) {

            columns.push({
                Header: "",
                headerClassName: "desktop",
                maxWidth: 180,
                className: "desktop text-center my-auto",
                Cell: this.renderButtonCell
            });
        }

        var gridContainerClass = "card px-0";
        // if (!this.props.displayAmounts)
        //     gridContainerClass += " col-12 col-xl-10";

        return (
            <div className={gridContainerClass}>
                <Grid data={this.state.items}
                    sortable={false}
                    showPagination={false}
                    pageSize={this.state.items.length}
                    columns={columns}
                    className="-highlight"
                    responsive={
                    [
                        {
                            breakpoint: 768,
                            columns: [
                                {
                                    Header: "",
                                    Cell: this.renderMobileCell
                                }
                            ]
                        }
                    ]} />
            </div>
        );
    }

    renderStdCell(cellInfo) {

        var cellValue;
        var formatter = cellInfo.column.formatter;

        if (cellInfo.column.dataType) {
            switch (cellInfo.column.dataType) {
                case "date":
                    formatter = Intl.DateTimeFormat(this.language, { month: "numeric", day: "numeric", year: "numeric" });
                    cellValue = formatter.format(Date.parse(cellValue));
                    break;
            }
        }

        if (formatter)
            cellValue = formatter.format(this.state.items[cellInfo.index][cellInfo.column.id]);
        else
            cellValue = this.state.items[cellInfo.index][cellInfo.column.id];

        var className = cellInfo.column.className ? cellInfo.column.className : "";

        return (
            <div
                style={{ backgroundColor: "rgba(rgba(0, 0, 0, 0.03))" }}
                contentEditable={false}
                suppressContentEditableWarning
            >
                <span className={className}>{cellValue}</span>
            </div>
        );
    }

    renderQtyCell(cellInfo) {

        var cellValue = 0.0;
        var unitOfMeasure = "";

        if (this.state.items.length > cellInfo.index)
        {
            cellValue = this.state.items[cellInfo.index][cellInfo.column.id];
            unitOfMeasure = this.state.items[cellInfo.index].SalesUnitDesc;
        }

        if (!this.props.detailsList) {   
            return (
                <div className={"form-group form-inline m-auto"}>
                    <input type="number" className={cellInfo.column.className + " form-control"} contentEditable
                        style={{ width: "65%", fontSize: "1rem" }}
                        defaultValue={cellValue}
                        onBlur={event => this.handleQuantityChange(event, cellInfo.index)}
                        onKeyPress={event => {
                            if (event.charCode === 13)
                                this.handleQuantityChange(event, cellInfo.index);
                        }}
                    />
                    <div className="color-primary4">{unitOfMeasure}</div>
                </div>
            );
        }
        else {
            return (
                <div className="text-center">
                    <div>{cellValue}<span className="ml-2 color-primary4">{unitOfMeasure}</span></div>
                </div>
            )
        }
    }

    renderButtonCell(cellInfo) {
        if (this.props.detailsList)
            return (<div className={cellInfo.column.className}></div>);
        else
            return (
                <button className="cmd-btn-outline-icon-danger mdi mdi-delete"
                    title={i18n.t("Αφαίρεση από το καλάθι")}
                    onClick={() => this.removeItem(cellInfo.index)}>
                </button>
            );
    }

    renderMobileCell(cellInfo) {
        
        var line = this.state.items[cellInfo.index];
        var quantity = line.Quantity;
        var unitOfMeasure = line.SalesUnitDesc;

        const editableDetails = (
            <div className="row">

                {
                    this.props.displayAmounts ?
                        (<div className="col-5 my-auto">
                            <div className="h6 color-success mt-1">{formatUnitPrice(line.UnitPrice)} / {line.SalesUnitId}</div>
                            <div className="h6 color-primary2">{formatCurrency(line.GrossValue)}</div>)
                        </div>)
                        : null
                }

                <div className="col-7 form-group form-inline my-auto">
                    <input type="number" className={cellInfo.column.className + " form-control"} contentEditable
                        style={{ width: "65%", fontSize: "1rem" }}
                        defaultValue={quantity}
                        onBlur={event => this.handleQuantityChange(event, cellInfo.index)}
                        onKeyPress={event => {
                            if (event.charCode === 13)
                                this.handleQuantityChange(event, cellInfo.index);
                        }} />
                    <div className="ml-2 color-primary4">{unitOfMeasure}</div>
                    <div className="col-1 my-auto h4 color-danger d-block mdi mdi-close"
                        onClick={() => this.removeItem(cellInfo.index)} />
                </div>
            </div>
        );

        const readOnlyDetails = (
            <div className="row my-auto">

                <div className="col-7">
                    <div >{quantity} <span className="color-primary4">{unitOfMeasure}</span></div>
                </div>

                {
                    this.props.displayAmounts ?
                        (<div className="col-5">
                            <div className="color-primary font-weight-medium text-right">{formatCurrency(line.GrossValue)}</div>
                        </div>)
                        : null
                }                
            </div>
            
        );

        return (
            <div className="px-1">
                <div className="row mb-2">
                    <div className="col-12 h5 text-wrap color-primary">{line.Description} ({line.ItemId})</div>
                </div>
                {this.props.detailsList? readOnlyDetails : editableDetails}
                
            </div >
        
        );
    }

    handleChange(event, _itemIndex) {
        this.state.items[_itemIndex].Quantity = event.target.value;
        this.notifyBasketModified();
    }

    renderMessage() {
        return (
            <Dialog
                message={this.state.errorMessage ?? this.state.warningMessage}
                type={this.state.errorMessage? "error" : this.state.warningMessage? "warning" : "info"}
                onConfirm={() => this.setState({ errorMessage: null, warningMessage: null})} />
        );
    }

    async handleQuantityChange(event, _itemIndex) {
        
        var input = event.target;

        try {
            
            if (input.value < 0.0) {
                input.value = 0.0;
            }

            if (input.value === '0' || input.value === '') {

                var response = await this.removeItem(_itemIndex);

                if (!response) {
                    input.value = SalesBasketManager.getItem(_itemIndex).Quantity;
                }

                return;
            }

            var quantity = input.value;

            if (SalesBasketManager.setItemQuantity(_itemIndex, quantity)) {
                this.setState({ items: SalesBasketManager.basketItems }, this.notifyBasketModified);
            }
            else {
                input.value = SalesBasketManager.getItem(_itemIndex).Quantity;
            }
        }

        catch (error) {
            Dialog.displayWarning(error.message);

            // Revert to original quantity
            if (input)
                input.value = SalesBasketManager.getItem(_itemIndex).Quantity;
        }
    }

    async removeItem(rowNumber) {

        var response = await Dialog.displayYesNoQuestion({
            title: SalesBasketManager.getItem(rowNumber).Description,
            message: i18n.t("Θέλετε να αφαιρέσετε το προϊόν από το καλάθι;")
        });

        if (response === true) {
            this.setState({ items: [] }, () => {
                this.setState({ items: SalesBasketManager.removeItem(rowNumber) });
                this.notifyBasketModified();
            });
        }

        return response;
        //We need to clear the grid items and reset them in order for the grid input fields to refresh properly. 
        // When setting the input defaultValue instead of the value property, the input does not refresh it's value correctly
    }

    notifyBasketModified() {
        if (this.props.onBasketModified)
            this.props.onBasketModified();
    }

    getDetailsData(_input) {
        let items = [];
        for (var i in _input) {

            if (!_input[i].LineItem)
                continue;
            
            items.push(_input[i]);
            items[i]['ItemCode'] = _input[i].LineItem['ItemCode'];
            items[i]['Description'] = _input[i].LineItem['Description'];
            items[i]['SalesUnitId'] = _input[i]['UnitId'];
            items[i]['SalesUnitDesc'] = _input[i].Unit['ShortDescription'];
        }
        return items;
    }
}

export default SalesBasketList;
